/*
 * Copyright (c) 2020. World Wide Generation Ltd
 */

import React from 'react';
import {
  InputColumn,
  TableColumn,
  TableInputProps,
  ValueTable,
} from './InputInterface';
import TableFactory, { TableTypes } from './TableFactory';
import { InputPlaceholderText } from '../../../../../constants/inputs';

interface TableInputFormProps extends TableInputProps {
  updateColumn: (update: InputColumn) => void;
  row: InputColumn[];
  multiRow: boolean;
  isColumnVisible: (code: string) => boolean
  placeholder?: string;
}

function createLabel(column: TableColumn) {
  const { name, shortName, instructions, code } = column;
  return (
    <>
      <label htmlFor={code} className='strong form-check-label'>
        {name || shortName || ''}
      </label>
      {instructions && <div className={'input-instructions'}>
        {instructions}
      </div>}
    </>
  )
}

function getPlaceholder(column: TableColumn, isAutoCalculated: boolean, multiRow: boolean, placeholder?: string) {

  if (!multiRow && placeholder && ['N/R', 'N/A'].includes(placeholder)) {
    return placeholder;
  }

  if (isAutoCalculated) {
    return '';
  }

  if (column.type === TableTypes.number) {
    return InputPlaceholderText.numeric;
  }

  if ((column.options && column.options.length > 0) || column.listId) {
    if (column.validation?.allowCustomOptions) {
      return InputPlaceholderText.dropdownOrCreate;
    }
    return InputPlaceholderText.dropdown;
  }

  return InputPlaceholderText.text;
}

export const TableInputForm = (props: TableInputFormProps) => {

  const { tableConfiguration, row, placeholder, multiRow, isColumnVisible } = props;

  const valueDataData = Array.isArray(props.valueDataData) ? [...props.valueDataData] : [];

  const { columns }: ValueTable = tableConfiguration;
  return <div className='questionWithFields inputGroupContainer'>
    {columns.map((column) => {
      const inputColumn = row.find(d => d.code === column.code) || { code: column.code }
      const isAutoCalculated = Boolean(column.calculation?.formula);
      if (!isColumnVisible(column.code)) {
        return null
      }
      return TableFactory({
        ...props,
        valueDataData,
        column,
        inputColumn,
        isAutoCalculated,
        placeholder: getPlaceholder(column, isAutoCalculated, multiRow, placeholder),
        label: createLabel(column)
      });
    })}
  </div>;
}
